import { IGeneralContractor } from '@apply/api/src/api/usersApi';
import { create } from 'zustand';

interface GeneralContractorStore {
    modalContractor: IGeneralContractor | undefined;
    set_modalContractor: (newContractor: IGeneralContractor) => void;
    reset_modalContractor: () => void;
    updateBfiAuthorized: (propertyId: number, isAuthorized: boolean) => void;
}

export const useGeneralContractorStore = create<GeneralContractorStore>((set) => ({
    modalContractor: undefined,
    set_modalContractor: (newModalContractor: IGeneralContractor) =>
        set((state) => ({
            modalContractor: { ...state.modalContractor, ...newModalContractor },
        })),
    reset_modalContractor: () => set({ modalContractor: undefined }),
    updateBfiAuthorized: (propertyId: number, isAuthorized: boolean) =>
        set((state) => {
            if (!state.modalContractor) return { modalContractor: undefined };

            const updatedProperties = state.modalContractor.properties.map((property) =>
                property.id === propertyId ? { ...property, bfiAuthorized: isAuthorized } : property
            );

            return { modalContractor: { ...state.modalContractor, properties: updatedProperties } };
        }),
}));
